import { render, staticRenderFns } from "./scene3Pc.vue?vue&type=template&id=64d92a15&scoped=true&"
import script from "./scene3Pc.vue?vue&type=script&lang=js&"
export * from "./scene3Pc.vue?vue&type=script&lang=js&"
import style0 from "./scene3Pc.vue?vue&type=style&index=0&id=64d92a15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d92a15",
  null
  
)

export default component.exports